import Chip from "@mui/material/Chip"

export default function SetupRequiredStatusChip() {
  return (
    <Chip
      label="Setup required"
      size="small"
      sx={(theme) => ({
        backgroundColor: theme.palette.grey[300],
        color: theme.palette.grey[800],
        fontWeight: 600,
      })}
    />
  )
}
